import gridTemplate from './grid.html';

@Inject('$transclude')
class GridController {
  constructor() {
    this.isHeader = this.$transclude.isSlotFilled('header');
  }
}

export default class GridComponent {
  constructor() {
    this.transclude = {
      header: '?gridHeader',
      actions: '?gridActions',
      table: 'gridTable',
      footer: '?gridFooter',
    };
    this.template = gridTemplate;
    this.controller = GridController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/grid/grid-component.js